module.exports = __webpack_public_path__ + "static/imgs/circle-outer2.e249a0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/circle/circle-outer2.png
// module id = JmxY
// module chunks = 1